/* ===================================================
   NATURAFRI — Theme JavaScript
   =================================================== */

'use strict';

/* === UTILITY === */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
const off = (el, ev, fn) => el && el.removeEventListener(ev, fn);
const debounce = (fn, ms = 200) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2).replace('.', ',');
  return amount + ' €';
}

/* === ANNOUNCEMENT BAR === */
(function() {
  const bar = $('#announcement-bar');
  const closeBtn = $('#announcement-bar-close');
  if (!bar || !closeBtn) return;
  const key = 'naturafri_ann_closed';
  if (sessionStorage.getItem(key)) { bar.classList.add('is-hidden'); return; }
  on(closeBtn, 'click', () => {
    bar.classList.add('is-hidden');
    sessionStorage.setItem(key, '1');
  });
})();

/* === STICKY HEADER === */
(function() {
  const header = $('.site-header');
  if (!header) return;
  let lastY = 0;
  const onScroll = () => {
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 10);
    lastY = y;
  };
  on(window, 'scroll', onScroll, { passive: true });
  onScroll();
})();

/* === MOBILE NAV === */
(function() {
  const toggle = $('#mobile-menu-toggle');
  const nav = $('#mobile-nav');
  const overlay = $('#menu-overlay');
  const closeBtn = $('#mobile-nav-close');
  if (!toggle || !nav) return;

  function open() {
    nav.classList.add('is-open');
    toggle.classList.add('is-open');
    if (overlay) { overlay.classList.add('is-visible'); overlay.removeAttribute('aria-hidden'); }
    document.body.style.overflow = 'hidden';
    nav.style.display = 'block';
  }
  function close() {
    nav.classList.remove('is-open');
    toggle.classList.remove('is-open');
    if (overlay) { overlay.classList.remove('is-visible'); overlay.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  on(toggle, 'click', open);
  on(closeBtn, 'click', close);
  on(overlay, 'click', close);
  on(document, 'keydown', e => { if (e.key === 'Escape') close(); });
})();

/* === CART DRAWER === */
const CartDrawer = (function() {
  const drawer = $('#cart-drawer');
  const overlay = $('#cart-overlay');
  const closeBtn = $('#cart-drawer-close');
  const body = $('#cart-drawer-body');
  let isOpen = false;

  function open() {
    if (!drawer) return;
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('is-visible'); overlay.removeAttribute('aria-hidden'); }
    document.body.style.overflow = 'hidden';
    refresh();
  }

  function close() {
    if (!drawer) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) { overlay.classList.remove('is-visible'); overlay.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  async function refresh() {
    if (!body) return;
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      render(cart);
    } catch (e) { console.error('Cart fetch error', e); }
  }

  function render(cart) {
    if (!body) return;
    updateCounts(cart.item_count);
    updateShippingBar(cart.total_price);
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="empty-state" style="padding:3rem 1rem;">
          <div class="empty-state__icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/>
            </svg>
          </div>
          <div class="empty-state__title">Votre panier est vide</div>
          <p class="empty-state__text">Découvrez nos produits africains authentiques</p>
          <a href="/collections/all" class="btn btn-primary" onclick="CartDrawer.close()">Voir la boutique</a>
        </div>`;
      return;
    }
    const items = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__image" src="${item.image ? item.image.replace('.jpg', '_80x80.jpg') : ''}" alt="${item.title}" width="80" height="80">
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__controls">
            <div class="quantity-selector" style="height:36px;">
              <button class="quantity-btn" data-action="decrease" data-key="${item.key}" style="height:36px;width:36px;font-size:1rem;">−</button>
              <input class="quantity-input" type="number" value="${item.quantity}" min="0" data-key="${item.key}" style="width:40px;height:36px;font-size:0.875rem;">
              <button class="quantity-btn" data-action="increase" data-key="${item.key}" style="height:36px;width:36px;font-size:1rem;">+</button>
            </div>
            <span class="cart-item__price">${formatMoney(item.final_line_price)}</span>
          </div>
          <button class="cart-item__remove" data-key="${item.key}">Supprimer</button>
        </div>
      </div>`).join('');

    const threshold = (window.Shopify && window.freeShippingThreshold) || 50;
    const remaining = threshold * 100 - cart.total_price;
    const shippingPct = Math.min(100, (cart.total_price / (threshold * 100)) * 100);
    const shippingHtml = `
    <div style="padding:1rem 1.5rem;background:var(--gray-100);border-bottom:1px solid var(--gray-200);">
        <div class="shipping-bar__text ${remaining <= 0 ? 'is-achieved' : ''}">
          ${remaining <= 0 ? '🎉 Livraison offerte !' : `Plus que <strong>${formatMoney(remaining)}</strong> pour la livraison offerte !`}
        </div>
        <div class="shipping-bar"><div class="shipping-bar__fill" style="width:${shippingPct}%"></div></div>
      </div>`;

    body.innerHTML = shippingHtml + `<div style="padding:0 1.5rem;">${items}</div>`;
    body.innerHTML += `
      <div class="cart-drawer__footer">
        <div class="cart-drawer__subtotal">
          <span>Sous-total</span>
          <span>${formatMoney(cart.total_price)}</span>
        </div>
        <a href="/checkout" class="btn btn-primary btn-full btn-lg">Commander — ${formatMoney(cart.total_price)}</a>
        <a href="/cart" class="btn btn-outline btn-full" style="margin-top:0.5rem;">Voir le panier</a>
        <p class="cart-drawer__note">Taxes et livraison calculées à la commande</p>
      </div>`;

    bindCartEvents();
  }

  function bindCartEvents() {
    on(body, 'click', async e => {
      const decreaseBtn = e.target.closest('[data-action="decrease"]');
      const increaseBtn = e.target.closest('[data-action="increase"]');
      const removeBtn = e.target.closest('.cart-item__remove');
      if (decreaseBtn) { await changeQuantity(decreaseBtn.dataset.key, -1); }
      if (increaseBtn) { await changeQuantity(increaseBtn.dataset.key, 1); }
      if (removeBtn) { await removeItem(removeBtn.dataset.key); }
    });
    on(body, 'change', async e => {
      if (e.target.classList.contains('quantity-input')) {
        const qty = parseInt(e.target.value) || 0;
        await setQuantity(e.target.dataset.key, qty);
      }
    });
  }

  async function changeQuantity(key, delta) {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      const item = cart.items.find(i => i.key === key);
      if (!item) return;
      const newQty = Math.max(0, item.quantity + delta);
      await setQuantity(key, newQty);
    } catch (e) { console.error(e); }
  }

  async function setQuantity(key, qty) {
    try {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await resp.json();
      render(cart);
    } catch (e) { console.error(e); }
  }

  async function removeItem(key) {
    await setQuantity(key, 0);
  }

  function updateCounts(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.dataset.count = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function updateShippingBar(totalPrice) { }

  if (closeBtn) on(closeBtn, 'click', close);
  if (overlay) on(overlay, 'click', close);
  on(document, 'keydown', e => { if (e.key === 'Escape' && isOpen) close(); });

  on(document, 'click', e => {
    if (e.target.closest('[data-open-cart]')) { e.preventDefault(); open(); }
  });

  return { open, close, refresh };
})();

window.CartDrawer = CartDrawer;

/* === ADD TO CART === */
async function addToCart(variantId, qty = 1, btn = null) {
  if (btn) {
    const orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner"></span>';
    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!resp.ok) throw new Error('Add to cart failed');
      btn.innerHTML = '✓ Ajouté !';
      btn.style.background = 'var(--green)';
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.disabled = false;
        btn.style.background = '';
      }, 2000);
      CartDrawer.open();
      showToast('Article ajouté au panier !', 'success');
    } catch (e) {
      btn.innerHTML = orig;
      btn.disabled = false;
      showToast('Erreur — réessayez.', 'error');
    }
  } else {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      CartDrawer.open();
    } catch (e) { console.error(e); }
  }
}

/* Quick add buttons on product cards */
on(document, 'click', e => {
  const btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  const variantId = btn.dataset.quickAdd;
  addToCart(variantId, 1, btn);
});

/* Main product form */
const productForm = $('#product-form');
if (productForm) {
  on(productForm, 'submit', async e => {
    e.preventDefault();
    const btn = productForm.querySelector('[type="submit"]');
    const fd = new FormData(productForm);
    const variantId = fd.get('id');
    const qty = parseInt(fd.get('quantity')) || 1;
    addToCart(variantId, qty, btn);
  });
}

/* Variant selection */
(function() {
  const variantBtns = $$('[data-variant-btn]');
  if (!variantBtns.length) return;
  const hiddenInput = $('[name="id"]', productForm);

  variantBtns.forEach(btn => {
    on(btn, 'click', () => {
      const option = btn.dataset.variantBtn;
      const name = btn.dataset.optionName;
      $$(`[data-option-name="${name}"]`).forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      updateVariant();
    });
  });

  function updateVariant() {
    const selected = {};
    $$('[data-variant-btn].is-active').forEach(btn => {
      selected[btn.dataset.optionName] = btn.dataset.variantBtn;
    });
    const variants = window.productVariants || [];
    const match = variants.find(v =>
      v.options.every((opt, i) => selected[v.option_names[i]] === opt)
    );
    if (match && hiddenInput) {
      hiddenInput.value = match.id;
      const priceEl = $('#product-price');
      const compareEl = $('#product-compare-price');
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (compareEl) {
        compareEl.textContent = match.compare_at_price > match.price ? formatMoney(match.compare_at_price) : '';
      }
      const submitBtn = productForm && productForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? 'Ajouter au panier' : 'Rupture de stock';
      }
    }
  }
})();

/* === PRODUCT GALLERY === */
(function() {
  const thumbs = $$('.product-gallery__thumb');
  const mainImg = $('.product-gallery__main img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(thumb => {
    on(thumb, 'click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.src;
      if (src) { mainImg.src = src; }
    });
  });
})();

/* === PRODUCT TABS === */
(function() {
  const tabs = $$('.product-tabs__btn');
  if (!tabs.length) return;
  tabs.forEach(tab => {
    on(tab, 'click', () => {
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');
      const target = tab.dataset.tab;
      $$('.product-tab-content').forEach(c => c.classList.remove('is-active'));
      const content = $(`[data-tab-content="${target}"]`);
      if (content) content.classList.add('is-active');
    });
  });
})();

/* === NEWSLETTER FORM === */
(function() {
  $$('.newsletter-form').forEach(form => {
    on(form, 'submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const emailInput = form.querySelector('[type="email"]');
      const successMsg = form.closest('.newsletter__form, .footer-newsletter-mini')?.querySelector('.newsletter__success');
      if (!emailInput || !emailInput.value) return;
      const origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Envoi...'; }
      await new Promise(r => setTimeout(r, 800));
      if (btn) { btn.disabled = false; btn.textContent = origText; }
      if (successMsg) { successMsg.classList.add('is-visible'); form.style.display = 'none'; }
      else { showToast('Merci ! Vous êtes inscrit(e) 🎉', 'success'); form.reset(); }
    });
  });
})();

/* === SCROLL REVEAL === */
(function() {
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('aos-animate');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  $$('[data-aos]').forEach(el => observer.observe(el));
})();

/* === SEARCH OVERLAY === */
(function() {
  const toggleBtn = $('#search-toggle');
  const searchOverlay = $('#search-overlay');
  const searchInput = searchOverlay && searchOverlay.querySelector('input');
  const closeBtn = searchOverlay && searchOverlay.querySelector('.search-overlay__close');
  if (!toggleBtn || !searchOverlay) return;
  on(toggleBtn, 'click', () => {
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    setTimeout(() => searchInput && searchInput.focus(), 100);
  });
  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }
  if (closeBtn) on(closeBtn, 'click', closeSearch);
  on(document, 'keydown', e => { if (e.key === 'Escape') closeSearch(); });
})();

/* === TOAST NOTIFICATION === */
function showToast(message, type = 'success') {
  const existing = $('.toast');
  if (existing) existing.remove();
  const icons = {
    success: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7 10l2 2 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/></svg>',
    error: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M10 6v4M10 14h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
  };
  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;
  toast.innerHTML = `<span class="toast__icon">${icons[type] || ''}</span><span>${message}</span>`;
  document.body.appendChild(toast);
  requestAnimationFrame(() => { requestAnimationFrame(() => toast.classList.add('is-visible')); });
  setTimeout(() => { toast.classList.remove('is-visible'); setTimeout(() => toast.remove(), 400); }, 3500);
}

window.showToast = showToast;

/* === STICKY ATC (mobile) === */
(function() {
  const bar = $('.sticky-atc');
  if (!bar) return;
  const addSection = $('.product-info__add-to-cart');
  if (!addSection) return;
  const observer = new IntersectionObserver(entries => {
    bar.style.display = entries[0].isIntersecting ? 'none' : 'flex';
  }, { threshold: 0 });
  observer.observe(addSection);
  const btn = bar.querySelector('.sticky-atc__btn');
  if (btn) {
    on(btn, 'click', () => {
      const mainBtn = document.querySelector('#product-form [type="submit"]');
      if (mainBtn) mainBtn.click();
    });
  }
})();

/* === COLLECTION SORT === */
(function() {
  const sortSelect = $('.collection-sort select');
  if (!sortSelect) return;
  on(sortSelect, 'change', () => {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location = url.toString();
  });
})();

/* === SMOOTH SCROLL FOR ANCHORS === */
on(document, 'click', e => {
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return;
  const target = $(anchor.getAttribute('href'));
  if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
});

/* === INIT CART COUNT === */
(async function() {
  try {
    const resp = await fetch('/cart.js');
    const cart = await resp.json();
    $$('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
      if (cart.item_count === 0) el.style.display = 'none';
    });
  } catch (e) { }
})();
